module.exports = __webpack_public_path__ + "static/financial_analysis.390d3837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/financial_analysis.png
// module id = 288
// module chunks = 35783957827783